module.exports = __webpack_public_path__ + "static/media/trainIcon.5a7ed752.png";